module.exports = __webpack_public_path__ + "img/ion-thruster.0b6ffcfe.png";